import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { ClienteAnaliseMercadoClienteModule } from '../../cliente';

import { ClienteAnaliseMercadoPerspectivaRAPComponent } from './cliente-analise-mercado-perspectiva-rap.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteAnaliseMercadoClienteModule
    ],
    declarations: [
        ClienteAnaliseMercadoPerspectivaRAPComponent
    ],
    exports: [
        ClienteAnaliseMercadoPerspectivaRAPComponent
    ],
    providers: [ ]
})
export class ClienteAnaliseMercadoPerspectivaRAPModule { }
